import { Logtail } from "@logtail/browser";
import * as Sentry from "@sentry/browser";

const errorLevels = ["debug", "info", "warn", "error"];
const betterStackToken = "5xTdkYSwefnJuTJrkTXm9UAw";

export const AimError = (message, context) => {
	const configLogLevel = window.serverdata.configMeta.aim?.logging?.logLevel.toLowerCase() || 'warn';
	const configLogEnabled = window.serverdata.configMeta.aim?.logging?.enabled || false;

	const errLevel = errorLevels.indexOf(configLogLevel);

	if (window.dev && (errLevel <= 3)) {
		Sentry.captureException(message);
	}

	if (configLogEnabled && errLevel <= 3) {
		const _logtail = new Logtail(betterStackToken);
		_logtail.error(message, {
			Client: window.serverdata.configMeta.aim.name,
			Url: document.location.href,
			// Context: context,
			Context: {
				path: context,
				referer: document.referrer,
			},
		});
	}
};

export const AimWarn = (message, context) => {
	const errLevel = errorLevels.indexOf(window.serverdata.configMeta.aim?.logging?.logLevel.toLowerCase());

	if (window.dev && errLevel >= 2) {
		Sentry.captureException(message);
	}

	if (window.serverdata.configMeta.aim?.logging?.enabled && errLevel <= 2) {
		const _logtail = new Logtail(betterStackToken);
		_logtail.warn(message, {
			Client: window.serverdata.configMeta.aim.name,
			Url: document.location.href,
			Context: context,
		});
	}
};

export const AimInfo = (message, context) => {
	const errLevel = errorLevels.indexOf(window.serverdata.configMeta.aim?.logging?.logLevel.toLowerCase());

	if (window.dev && errLevel >= 1) {
		Sentry.captureMessage(message);
	}

	if (window.serverdata.configMeta.aim?.logging?.enabled && errLevel <= 1) {
		const _logtail = new Logtail(betterStackToken);
		_logtail.info(message, {
			Client: window.serverdata.configMeta.aim.name,
			Url: document.location.href,
			Context: context,
		});
	}
};

export const AimDebug = (message, context) => {
	const errLevel = errorLevels.indexOf(window.serverdata.configMeta.aim?.logging?.logLevel.toLowerCase());

	if (window.dev && errLevel >= 0) {
		Sentry.captureMessage(message);
	}

	if (window.serverdata.configMeta.aim?.logging?.enabled && errLevel <= 0) {
		const _logtail = new Logtail(betterStackToken);
		_logtail.debug(message, {
			Client: window.serverdata.configMeta.aim.name,
			Url: document.location.href,
			Context: context,
		});
	}
};
